import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import Checkbox from "./checkbox";
import Icon from "../elements/icon";
import classNames from "classnames";
import Popover from "../overlays/popover-2";

export default class BulkSelect extends React.Component {
  static displayName = "BulkSelect";

  static propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    partial: PropTypes.bool, // must combine with props.checked
    label: PropTypes.node,
    actions: PropTypes.func, // ({closePopover})
  };
  static defaultProps = {
    label: "Options",
    actions: _.noop,
    onChange: _.noop,
    checked: false,
    partial: false,
  };
  render() {
    const { checked, onChange, partial, label, actions } = this.props;
    return (
      <Popover
        disabled={!checked}
        wrapperClassName="et--bulk-select--popover-wrapper"
        contentClassName="et--bulk-select--popover-content"
        trigger={({ is_open, openPopover, closePopover }) => (
          <div className="et--bulk-select">
            <Checkbox checked={checked} onChange={onChange} partial={partial} />
            <div
              className={classNames("et--bulk-select--trigger", {
                "is-active": checked,
              })}
              onClick={() => (is_open ? closePopover() : openPopover())}
            >
              {label}
              <Icon icon={is_open ? "chevron-up" : "chevron-down"} />
            </div>
          </div>
        )}
      >
        {actions}
      </Popover>
    );
  }
}
